import { Button, Grid, IconButton, Tooltip } from "@mui/material";
import { IconPlus, IconX } from "@tabler/icons";
import { FieldArray } from "formik";
import React from "react";
import { InputField, SelectField } from "../../../../utils/FormFields";
import { useFormikContext } from "formik";
import { FormikProps, FormikValues } from "formik";
import { Equipment } from "../../../../api/medical-operations";

const PrescribedEquipments = ({ equipment }: any) => {
  const formik: FormikProps<FormikValues> = useFormikContext();

  const availableEquipment = equipment?.map((equipment: Equipment) => {
    return {
      label: equipment?.Name,
      value: equipment?.Code,
    };
  });

  return (
    <>
      <FieldArray
        name={`PrescribedEquipments`}
        render={(arrayHelpers) => (
          <>
            <Button
              onClick={() => {
                arrayHelpers.push("");
              }}
              color="primary"
              variant="outlined"
              sx={{ p: 1, ml: 1 }}
            >
              <IconPlus />
              Add Equipment
            </Button>
            <Grid
              container
              rowSpacing={4}
              spacing={4}
              sx={{
                pt: 8,
                justifyContent: "center",
                alignContent: "center",
              }}
            >
              {formik?.values?.PrescribedEquipments?.map((jump: any, index: number) => (
                <>
                  <Grid
                    container
                    rowSpacing={6}
                    spacing={2}
                    sx={{ pt: 2, justifyContent: "center", alignContent: "center" }}
                  >
                    <Grid item xs={12} sm={2}>
                      <SelectField
                        name={`PrescribedEquipments[${index}].Code`}
                        label="Equipment"
                        data={availableEquipment}
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      <InputField
                        name={`PrescribedEquipments[${index}].Duration`}
                        label="Duration"
                        fullWidth
                        type="number"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <InputField
                        name={`PrescribedEquipments[${index}].Notes`}
                        label="Notes"
                        fullWidth
                        variant="filled"
                      />
                    </Grid>
                    <Grid item xs={4} sm={1}>
                      <Tooltip title="Delete">
                        <IconButton onClick={() => arrayHelpers.remove(index)}>
                          <IconX color="red" />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  </Grid>
                </>
              ))}
            </Grid>
          </>
        )}
      />
    </>
  );
};
export default PrescribedEquipments;
